<template>
  <section class="list-box">
    <div class="setting-table">
      <table>
        <tr>
          <th>メールアドレス</th>
          <td>
            <input type="text" v-model="tempCorporation.email" name="email" />
            <div>
              <span class="error">{{ errorMessage }}</span>
            </div>
          </td>
        </tr>
        <tr>
          <th>業種</th>
          <td>
            <select v-model="tempCorporation.sectorsName">
              <option
                v-for="sector in sectors"
                v-bind:value="sector.name"
                v-bind:key="sector.id"
              >
                {{ sector.name }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <th>貴社名</th>
          <td>
            <input type="text" v-model="tempCorporation.name" name="name" />
          </td>
        </tr>
        <tr>
          <th>部署名</th>
          <td>
            <input
              type="text"
              v-model="tempCorporation.department"
              name="department"
            />
          </td>
        </tr>
        <tr>
          <th>ご担当者様お名前</th>
          <td>
            <input
              type="text"
              v-model="tempCorporation.officerName"
              name="officerName"
            />
          </td>
        </tr>
        <tr>
          <th>ご担当者様お名前（カナ）</th>
          <td>
            <input
              type="text"
              v-model="tempCorporation.officerNameKana"
              name="officerNameKana"
            />
          </td>
        </tr>
        <tr>
          <th>役職</th>
          <td>
            <input
              type="text"
              v-model="tempCorporation.position"
              name="position"
            />
          </td>
        </tr>
        <tr>
          <th>国・地域</th>
          <td>
            <select v-model="tempCorporation.country">
              <option
                v-for="country in countries"
                v-bind:value="country.value"
                v-bind:key="country.id"
              >
                {{ country.name }}
              </option>
            </select>
          </td>
        </tr>
        <tr v-if="tempCorporation.country === 0">
          <th>郵便番号</th>
          <td>
            <input type="text" v-model="tempCorporation.zipCode" name="zipCode"/>
          </td>
        </tr>
        <tr v-if="tempCorporation.country === 0">
          <th>都道府県</th>
          <td>
            <select v-model="tempCorporation.prefectures">
              <option
                v-for="area in areas"
                v-bind:value="area.value"
                v-bind:key="area.id"
              >
                {{ area.prefecture }}
              </option>
            </select>
          </td>
        </tr>
        <tr v-if="tempCorporation.country === 0">
          <th>市区町村番地</th>
          <td>
            <input type="text" v-model="tempCorporation.municipalities" name="municipalities" />
          </td>
        </tr>
        <tr v-if="tempCorporation.country === 0">
          <th>建物名・部屋番号</th>
          <td>
            <input type="text" v-model="tempCorporation.building" name="building" />
          </td>
        </tr>
        <tr>
          <th>電話番号</th>
          <td>
            <input type="text" v-model="tempCorporation.tel" tel="tel" />
          </td>
        </tr>
      </table>
    </div>
    <div class="btn-set">
      <span class="btn-gray2">
        <button @click="backBtnClick">前の画面に戻る</button>
      </span>
      <span class="btn-gray2">
        <button @click="nextBtnClick">次へ</button>
      </span>
    </div>
  </section>
</template>>
<script>
import httpResource from '../http/httpResource'
import store from '../store/index'
import { mapGetters } from 'vuex'
import { parseApierror } from '../util/utils'
export default {
  props: ['tempCorporation'],
  data () {
    return {
      displayErrorMessage: false,
      errorMessage: '',
      countries: [
        { id: 0, value: 0, name: '日本' },
        { id: 1, value: 1, name: '日本以外' }
      ],
      areas: [
        { id: 1, value: '1', prefecture: '北海道' },
        { id: 2, value: '2', prefecture: '青森県' },
        { id: 3, value: '3', prefecture: '岩手県' },
        { id: 4, value: '4', prefecture: '宮城県' },
        { id: 5, value: '5', prefecture: '秋田県' },
        { id: 6, value: '6', prefecture: '山形県' },
        { id: 7, value: '7', prefecture: '福島県' },
        { id: 8, value: '8', prefecture: '茨城県' },
        { id: 9, value: '9', prefecture: '栃木県' },
        { id: 10, value: '10', prefecture: '群馬県' },
        { id: 11, value: '11', prefecture: '玉県' },
        { id: 12, value: '12', prefecture: '千葉県' },
        { id: 13, value: '13', prefecture: '東京都' },
        { id: 14, value: '14', prefecture: '神奈川県' },
        { id: 15, value: '15', prefecture: '新潟県' },
        { id: 16, value: '16', prefecture: '富山県' },
        { id: 17, value: '17', prefecture: '石川県' },
        { id: 18, value: '18', prefecture: '福井県' },
        { id: 19, value: '19', prefecture: '山梨県' },
        { id: 20, value: '20', prefecture: '山梨県' },
        { id: 21, value: '21', prefecture: '岐阜県' },
        { id: 22, value: '22', prefecture: '静岡県' },
        { id: 23, value: '23', prefecture: '愛知県' },
        { id: 24, value: '24', prefecture: '三重県' },
        { id: 25, value: '25', prefecture: '滋賀県' },
        { id: 26, value: '26', prefecture: '京都府' },
        { id: 27, value: '27', prefecture: '大阪府' },
        { id: 28, value: '28', prefecture: '兵庫県' },
        { id: 29, value: '29', prefecture: '奈良県' },
        { id: 30, value: '30', prefecture: '和歌山県' },
        { id: 31, value: '31', prefecture: '鳥取県' },
        { id: 32, value: '32', prefecture: '島根県' },
        { id: 33, value: '33', prefecture: '岡山県' },
        { id: 34, value: '34', prefecture: '広島県' },
        { id: 35, value: '35', prefecture: '山口県' },
        { id: 36, value: '36', prefecture: '徳島県' },
        { id: 37, value: '37', prefecture: '香川県' },
        { id: 38, value: '38', prefecture: '愛媛県' },
        { id: 39, value: '39', prefecture: '高知県' },
        { id: 40, value: '40', prefecture: '福岡県' },
        { id: 41, value: '41', prefecture: '佐賀県' },
        { id: 42, value: '42', prefecture: '長崎県' },
        { id: 43, value: '43', prefecture: '熊本県' },
        { id: 44, value: '44', prefecture: '大分県' },
        { id: 45, value: '45', prefecture: '宮崎県' },
        { id: 46, value: '46', prefecture: '鹿児島県' },
        { id: 47, value: '47', prefecture: '沖縄県' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      sectors: 'getSectors',
      corporation: 'getCorporation'
    })
  },
  watch: {
    'tempCorporation.sectorsName': function (newVal, oldVal) {
      this.tempCorporation.sectorsId = this.sectors.find((e) => {
        return e.name === newVal
      }).id
    }
  },
  methods: {
    backBtnClick () {
      this.$emit('back')
    },
    async nextBtnClick () {
      if (this.tempCorporation.email !== this.corporation.email) {
        try {
          const response = await httpResource.post(
            '/corporation/users/check-email',
            this.tempCorporation.email,
            {
              headers: {
                Authorization: `Bearer ${store.getters.getAuthData.token}`
              }
            }
          )
          if (response.status === 200) {
            this.$emit('next')
          }
        } catch (error) {
          const apierror = parseApierror(error)
          this.displayErrorMessage = true
          this.errorMessage = apierror.message
        }
      } else {
        this.$emit('next')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UpdateAccount.vue